// extracted by mini-css-extract-plugin
module.exports = {"DialogContent":"ReportButton_DialogContent__3EY07"};